import Alpine from 'alpinejs';
import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'jquery-mask-plugin';

import hljs from 'highlight.js/lib/core';
import json from 'highlight.js/lib/languages/json';
hljs.registerLanguage('json', json);

window.Alpine = Alpine;
window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
window.toastr = require("toastr");
window.moment = require("moment");
window.hljs = hljs;
window.daterangepicker = require('bootstrap-daterangepicker');

FilePond.registerPlugin(FilePondPluginFileValidateType);

window.FilePond = FilePond;

import { Player } from './player';
document.addEventListener("DOMContentLoaded", () => {
    new Player(document.querySelector('#playerContainer'));
});

require('./bootstrap');
import 'bootstrap-datepicker';

// CoreUI
require('@coreui/coreui-pro');
window.Utils = require("@coreui/utils");

// Boilerplate
require('./plugins');

import token from './alpine/token';

Alpine.data('tokenComponent', token);

Alpine.start();
